import React, { createContext, useContext, useEffect } from 'react';

const LandingThemeContext = createContext();

export const useLandingTheme = () => {
  const context = useContext(LandingThemeContext);
  if (!context) {
    throw new Error('useLandingTheme must be used within a LandingThemeProvider');
  }
  return context;
};

export const LandingThemeProvider = ({ children }) => {
  useEffect(() => {
    // Force dark mode for landing pages
    const root = document.documentElement;
    root.classList.add('dark');
    
    // Store the original theme preference
    const originalTheme = localStorage.getItem('theme');
    if (originalTheme) {
      localStorage.setItem('original-theme', originalTheme);
    }
    
    // Set landing pages to always use dark mode
    localStorage.setItem('theme', 'dark');
    
    // Cleanup function to restore original theme when leaving landing pages
    return () => {
      const storedOriginalTheme = localStorage.getItem('original-theme');
      if (storedOriginalTheme) {
        localStorage.setItem('theme', storedOriginalTheme);
        if (storedOriginalTheme === 'dark') {
          root.classList.add('dark');
        } else {
          root.classList.remove('dark');
        }
        localStorage.removeItem('original-theme');
      }
    };
  }, []);

  const value = {
    isDarkMode: true, // Always true for landing pages (always dark mode)
    toggleTheme: () => {
      // No-op for landing pages - theme is always dark
      console.log('Theme toggle disabled on landing pages');
    }
  };

  return (
    <LandingThemeContext.Provider value={value}>
      {children}
    </LandingThemeContext.Provider>
  );
};

export default LandingThemeContext;
